<template>
    <section>
        <!--工具条-->
        <el-col v-show="!hideToolbar" :span="24" class="toolbar">
            <el-form :inline="true">
                <el-button v-if="packUpBtn" type="success" size="small" :icon="packupIcon"
                           style="margin: 5px 0px" @click="packUp"></el-button>
                <el-form-item v-if="title">
                    <el-tag size="medium" type="gray">{{title}}</el-tag>
                </el-form-item>
                <el-form-item  v-for="(item,index) in filters" v-if="filters&&item.type!='hidden'" v-show="index<showFilterCount || vCondition"  v-bind:style="filterWidth(item)"  >
                    <!--string-->
                    <el-input v-if="item.type=='string'" v-model="item.value" :placeholder="item.text" v-bind:style="filterWidth(item)"></el-input>
                    <!--checkbox-->
                    <el-tag v-if="item.type=='checkbox'" type="gray">{{item.text}}：</el-tag>
                    <span v-if="item.type=='checkbox'"  v-for="itemCb in item.value">
                        <el-checkbox v-model="itemCb[2]">{{itemCb[1]}}</el-checkbox>&nbsp
                    </span>
<el-radio-group v-if="item.type=='radio'" v-model="item.value">
                        <el-radio :label="itemCb[0]" v-for="itemCb in item.data">{{itemCb[1]}}</el-radio>
                    </el-radio-group>
                    <!--datetime-->
                    <sy-dataPicker v-if="item.type=='date'" v-bind:style="filterWidth(item)"
                                   v-model="item.value"
                                   :type="item.dateType?item.dateType:'daterange'"
                                   :placeholder="item.text">
                    </sy-dataPicker>
                    <sy-select  @change="searchChange" noMatchValue="undefind" v-bind:style="filterWidth(item)"
                                v-if="item.type=='select'" v-model="item.value" :placeholder="item.text"
                                :valueKey="item.valueKey"  :labelKey="item.labelKey" :remote="item.loadRemote"
                                :optionData="item.data" :extendData="item.name">
                    </sy-select>
                    <!--年限的特殊处理，需要重构-->
                    <div v-if="item.type=='period'">
                        <el-date-picker :type="item.dateType" :placeholder="item.text" v-model="item.value"  style="width: 130px"></el-date-picker>
                        <span>--</span>
                        <el-date-picker :type="item.dateType" :placeholder="item.text2" v-model="item.value2"  style="width: 130px"></el-date-picker>
                    </div>
                    <!--数字范围，需要重构-->
                    <div v-if="item.type=='number'">
                        <el-input v-model="item.value" :placeholder="item.text" style="width: 80px"></el-input>
                        <span>--</span>
                        <el-input v-model="item.value2" :placeholder="item.text2" style="width: 80px"></el-input>
                    </div>
                      <sy-cascader noMatchValue="undefind" v-bind:style="filterWidth(item)"
                                 v-if="item.type=='cascader'" v-model="item.value" :placeholder="item.text" :remote="item.loadRemote" :optionsData="item.data">
                    </sy-cascader>
                </el-form-item>

                <el-form-item  v-if="filters">
                    <el-button v-if="filters && filters.length>showFilterCount" size="small" :icon="cdtnIcon" @click="openCondition"></el-button>
                    <el-button v-if="!hideSearchBtn" type="primary" @click="searchByBtn">查询</el-button>
                </el-form-item>
                <el-form-item  v-if="!hideAdd && authAdd">
                    <el-button  type="primary" @click="handleAdd()">新增</el-button>
                </el-form-item>

                <el-form-item  v-if="multipleSelection.length>0 && !hideDelAll">
                    <el-button  type="danger" @click="handleDeleteAll">删除选中</el-button>
                </el-form-item>
                <el-form-item  v-if="multipleSelection.length>0 && showSelect">
                    <el-button  type="success" @click="handleSelectAll">选择选中</el-button>
                </el-form-item>
                <el-form-item>
                    <slot name="extendbtnTop">
                        <!---top扩展按钮-->
                    </slot>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <template>
            <el-table ref="table"
                      :header-cell-style="{background:'#eef1f6',color:'#333'}"
                      :border="border"
                      :row-style="rowStyle"
                      :row-key="IDKey"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :data="listData"
                      :showHeader="!hideHeader"
                      highlight-current-row
                      default-expand-all
                      v-loading="listLoading"
                      @current-change="currentChange"
                      @row-dblclick="rowDblclick"
                      :row-class-name="tableRowClassName"
                      @selection-change="handleSelectionChange"
                      :summary-method="getSummaries"
                      :show-summary="showSummary"
                      @sort-change="sortchange"
                      :tablename="tablename"
                      :span-method="SpanMethod"
                      :height="height"
            >
                <el-table-column v-if="mutilSelect" type="selection" width="55">
                </el-table-column>
                <slot>
                    <!-- -列-->
                </slot>

                <el-table-column  min-width="150px" :width="operateWidth" :fixed="fixedOperate" v-if="!hideOperate"  :context="_self" align="left" label="操作">
                  <template slot-scope="btn">
                    <slot name="extendbtn" :row="btn.row">
                      <!---扩展按钮-->
                    </slot>
                         <el-button v-if="showSelect"  type="success"  size="small" style="margin-left: 0px;" class="el-button el-button--text el-button--mini"  @click="handleSelect(btn.row)"><i class="el-icon-circle-check"></i><span>选择</span></el-button>
                         <!--TODO：使用row.hideEditBtn不好，污染了数据。需要重新设计-->
                         <el-button v-if="ApproveID" size="small"  style="margin-left: 0px;" class="el-button el-button--text el-button--mini" @click="handleApprove(btn.row)">{{getApproveTitle(btn.row)}}</el-button>
                         <el-button v-if="!hideEdit && authEdit && !btn.row.hideEditBtn" size="small" class="el-button el-button--text el-button--mini"  style="margin-left: 0px;" @click="handleEdit(btn.row)"><i class="el-icon-edit"></i><span>{{getEditTitle(btn.row)}}</span></el-button>
                         <DelPoperver v-if="!hideDel && authDel && !btn.row.hideDeleteBtn"    v-on:done="handleDel(btn.row)"><i class="el-icon-delete"></i><span>删除</span></DelPoperver>
                    <slot name="extendbtn_end" :row="btn.row">
                      <!---扩展按钮-->
                    </slot>
                    </template>

                </el-table-column>
            </el-table>
        </template>

        <!--分页-->

        <el-col :span="24" class="toolbar" style="padding-bottom:10px;float: none;height:50px">
            <el-pagination v-if="!hidePagination"  layout="total,prev, pager, next,jumper"
                           @current-change="handleCurrentChange" @size-change="handleSizeChange"
                           :page-size="pageSize" :total="total" style="float:right;">
            </el-pagination>
        </el-col>
    </section>
</template>

<script>
    import Vue from 'vue'
    import util from '../common/util'
    import Const from '../common/const'
    import DelPoperver from "../components/DelPoperver.vue"
    export default {
        props: {
            autoSearch: {type: Boolean, default: true}, //创建就自动查询加载数据
            ApproveID:Number,  //流程ID
            border:{type: Boolean, default: true}, //表格是否有线框
            deleteUrl:String,    //删除的提交的url
            deleteAllUrl:String, //全部删除的提交的url
            editVue:String,          //编辑界面的路径
            fixWhere:String,  //固定的过滤条件，不管何时，查询总会带上该条件
            filters:Array,    //过滤条件的控件配置
            fixOperate:Boolean, //是否固定操作栏
            hideToolbar:Boolean,    //是否隐藏工具栏（查询、新增等）
            hidePagination:Boolean, //是否隐藏分页
            hideHeader:Boolean,  //是否隐藏标题
            hideAdd:Boolean,     //是否隐藏新增按钮
            hideDelAll:Boolean,  //是否隐藏删除全部按钮
            hideEdit:Boolean,    //是否隐藏编辑按钮
            hideDel:Boolean,     //是否隐藏删除按钮
            hideOperate:Boolean, //是否隐藏操作栏
            hideSearchBtn:Boolean,//是否隐藏查询按钮
            IDKey:{type: String, default: "FID"}, //表主键
            initWhere:String, //初始化的过滤条件，重新选择查询条件后，该条件不再起作用
            initOWhere:Object,//固定的过滤条件key:value形式，在后台构造条件，不管何时，查询总会带上该条件
            listUrl:String,       //获取数据的url
            mutilSelect: {type:Boolean, default:false},         //是否可多选
            operateWidth:{type: String, default: ""},           //操作栏的宽度
            pageSize: {type: Number, default: 15},  //分页每页条数
            packUpBtn: {type:Boolean, default:false}, //是否有收起按钮
            rowStyle:Function,         //行样式，可用于改变行颜色
            reuseEditForm:{type: Boolean, default: false}, //编辑界面是否重复利用,是则只创建一次，性能更快。但一些状态不清除的话会共用
            showFilterCount:{ //默认显示查询条件的控件数，不显示的会收起来
                type: Number,
                default: 100 //全部显示
            },
            showSelect:Boolean,  //是否显示选择返回按钮
            showSummary:Boolean, //是否显示合计行
            title:String,            //标题
	        tablename:String,
            SpanMethod:Function,  //合并列头
			needAuth:{            //是否需要权限
                type: Boolean,
                default: true
            },
            height:0
        },
        watch:{
            //初始化mounted之前，watch是不会触发的
            initWhere(val){
                this.search(this.initWhere)
            },
            fixWhere(val){
                this.search(null,val)
            },
//            oWhere(val){
//                this.search(null,this.fixWhere,val)
//            }
        },
        data() {
            return {
                //height:window.innerHeight*0.8,
                pickerOptions:Const.pickerOptions,
                showPage:true,
                listData: [],
                total: 0,
                page: 1,
                listLoading: false,
                orderby:"",
                ordertype:"",
                where:this.initWhere,//内部变量，允许修改
                fixWhere_:this.fixWhere, //内部变量，允许修改
                oWhere:this.initOWhere,//内部变量，允许修改
                authAdd:true,
                authEdit:true,
                authDel:true,
                vCondition:false,
                cdtnIcon:"d-arrow-right",
                packupIcon:"el-icon-caret-left",
                EditForm:null,
                multipleSelection:[],
                sumData:null
            }
        },
        computed:{
            fixedOperate(){
                return this.fixOperate?"right":false
            }
        },
        components:{
            DelPoperver:DelPoperver
        },
        methods: {
            //----对外函数------------------
            _getSelections(){
                return this.multipleSelection
            },
            _getSelectionIDs(){
                let result = []
                for(let item of this.multipleSelection){
                    result.push(item[this.IDKey])
                }
                return result
            },
            _refrash(){
                this.search();
            },
            _search(where,fixWhere,oWhere){
                this.search(where,fixWhere,oWhere);
            },
            _wherePara(){
                return {
                    start: (this.page-1)*this.pageSize,
                    limit: this.pageSize,
                    orderby: this.orderby,
                    ordertype: this.ordertype,
                    where: util.joinWhere(this.fixWhere_,this.where,this.getWhere(this.filters)),
                    oWhere:this.getOWhere(this.filters)
                }
            },
            //----对外函数------------------
            filterWidth(item){
                if(item.width){
                    return  {
                        width: item.width+"px"
                    }
                }
                else if(item.type=='date'){
                    return  {
                        width: "225px"
                    }
                }
                else if(item.type=='period'){
                    return  {
                        width: "300px"
                    }
                }
                else if(item.type=='numberrange') {
                    return  {
                        width: "180px"
                    }
                }
                else if(item.type=='checkbox'){
                    return  {
                        width: "auto"
                    }
                }
                else{
                    return  {
                        width: "130px"
                    }
                }
            },
            //获取用户列表
            search(where,fixWhere,oWhere) {
                if(fixWhere!=undefined && fixWhere!=null){
                    this.fixWhere_ = fixWhere
                }
                if(where!=undefined && where!=null){
                    this.where = where
                }
                if(oWhere!=undefined && oWhere!=null){
                    this.oWhere = oWhere
                }
                let para = {
                    start: (this.page-1)*this.pageSize,
                    limit: this.pageSize,
                    orderby: this.orderby,
                    ordertype: this.ordertype,
                    where: util.joinWhere(this.fixWhere_,this.where,this.getWhere(this.filters)),
                    oWhere: Object.assign({},this.getOWhere(this.filters),this.oWhere)
                };
                this.$emit("beforeSearch",para)
                util.get(this.listUrl,para,this.switchLoading,result=> {
                    this.total = result.totalCount;
                    this.sumData = result.sumData;
                    //临时加的,处理chileren的时间
                    result.data.forEach(item=>{
			 		   item.children = util.date.formatArr(item.children)}
                    )
                    this.listData = util.date.formatArr(result.data);
                    if(this.listData)
                    {
                        for(let row of this.listData)
                        {
                            this.$emit("onLoadRow",row)
                        }
                    }
                    this.$emit("onLoadData",this.listData,result)
                    //this.$emit("onLoadData",this.listData)
                    //TODO:默认选中第一行
//                    if(this.listData && this.listData.length>0) {
//                        Vue.nextTick(()=>
//                           this.$refs.table.toggleRowSelection(this.listData[0],true)
//                    }
                    //默认选中第一条
//                    if(this.listData && this.listData.length>0) {
//                        this.currentChange(this.listData[0])
//                    }
                });
            },
            setcolumnwidth(){
			   //@header-dragend="headerdragend"
              //先处理列宽
              let widthpara = { tablename: this.tablename }
              util.get('server/system/TableSetting.ashx?cmd=GetList',widthpara,this.switchLoading,result=> {
                  var columnwidth = result.data
                  var columns = this.$refs.table.columns
                  if (columnwidth) {
                    for (var item = 0; item < columns.length; item++) {
                      for(var i=0;i<columnwidth.length;i++){
                        if(columns[item].property==columnwidth[i].columnName){
                          columns[item].width = parseFloat(columnwidth[i].width)
                          break;
                        }
                      }
                    }
                  }
              })
            },
            onSaveSuc:function (row) {
                this.search();
            },
            switchLoading:function(flag){
                this.listLoading = flag
            },
            handleCurrentChange(val) {
                this.page = val;
                this.search();
            },
            handleSizeChange(val){
                this.pageSize = val
                this.search();
            },
            searchByBtn(e){
                this.search("");
            },
            //删除
            handleDel: function (row) {
                if(!util.emit(this,"beforeDelete",row)){
                    return;
                }
                let para = {}
                para[this.IDKey] = row[this.IDKey]
                util.post(this.deleteUrl,para,this.switchLoading,result=> {
                    util.msgSuc("删除成功")
                    this.search()
                    this.$emit("afterDelete",row)
                })
            },
            //多选删除
            handleDeleteAll: function(){
                let ids=this._getSelectionIDs();
                let Rows = this._getSelections();
                if(ids.length==0){
                    util.msgWarning("请选择记录")
                }
                if(!util.emit(this,"beforeDeleteAll",Rows,ids)){
                    return;
                }
                let para = {ids:ids.join(",")}
                this.$confirm('删除后不可恢复，确认删除吗?', '提示', {
                    //type: 'warning'
                }).then(()=>{
                    util.post(this.deleteAllUrl,para,this.switchLoading,result=> {
                        util.msgSuc("删除成功")
                        this.search()
                        this.$emit("afterDeleteAll",Rows,ids)
                    })}).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (row) {
                if(!util.emit(this,"beforeEdit",row)){
                    return;
                }
                this.createEditForm()._openEdit(row,this.authEdit);
            },
            //显示新增界面
            handleAdd: function (init) {
                let row = init || {}
                if(!util.emit(this,"beforeAdd",row)){
                    return;
                }
                this.createEditForm()._openAdd(row,this.authAdd)
            },
            handleSelect:function (row) {
                this.$emit("onSelect",row)
            },
            handleSelectAll:function () {
                let ids=this._getSelectionIDs();
                let Rows = this._getSelections();
                if(ids.length==0){
                    util.msgWarning("请选择记录")
                }
                this.$emit("onSelectAll",Rows,ids)
            },
            currentChange(row,oldRow){
                this.$emit("current-change",row,oldRow)
            },
            rowDblclick(row){
                if(this.showSelect) {
                    this.$emit("onSelect", row)
                }
                else{
                    this.handleEdit(row)
                }
            },
            tableRowClassName(row, index) {
                var r = {};
                util.emit(this,"row-class-name",row,index,r)
                return r.className;
            },
            //特殊条件，以key:value传到服务端，再在服务端构造
            getOWhere(filters){
                let result = {}
                if(filters) {
                    for (let i = 0; i < filters.length; i++) {
                        let item = filters[i];
                        if (item.value && item.remote) {
                            if (item.type == "cascader") {
                                let val = null
                                if(item.value.length>0){
                                    val = item.value[item.value.length-1]
                                }
                                let a = typeof(val)=="string"?"'" + val+ "'": val;
                                result[item.name] = a
                            }
                            else {
                                result[item.name] = item.value
                            }
                        }
                    }
                }
                return result
            },
            isEmpty(item){
                if(item.type == "numberrange"){
                    return (item.value===undefined || item.value==="" || item.value===null)
                        && (item.value2===undefined || item.value2==="" || item.value2===null)
                }else  if(item.type == "period"){
                    return (item.value===undefined || item.value==="" || item.value===null)
                        || (item.value2===undefined || item.value2==="" || item.value2===null)
                }
                else{
                    return item.value===undefined || item.value==="" || item.value===null
                }
            },
            //构造查询条件
            getWhere(filters) {
                //TODO:安全起见，需要到移动服务端去实现
                let result =  ""
                if(filters){
                    for(let i=0;i<filters.length;i++){
                        let item = filters[i];
                        if(!this.isEmpty(item)) {
                            if(item.remote){  //特殊条件，以key:value传到服务端，再在服务端
                                continue
                            }
                            if (item.type == "string") {
                                result = util.joinWhere(result,item.name + " like '%" + item.value + "%'")
                            } else if (item.type == "select") {
                                if(item.equal=="like"){
                                    result = util.joinWhere(result,item.name + " like '%" + item.value + "%'")
                                }else {
                                    let a = typeof(item.value)=="string"?"'" + item.value + "'": item.value
                                    result = util.joinWhere(result, item.name + "=" + a)
                                }
                            } else if (item.type == "date") {
                                if(item.value[0] && item.value[1]) {
                                    let bDate = util.date.format(item.value[0], 'yyyy-MM-dd')
                                    let eDate = util.date.format(item.value[1], 'yyyy-MM-dd 23:59:59')
                                    result = util.joinWhere(result,item.name + ">='" + bDate + "' and " + item.name + "<'" + eDate + "'")
                                }
                            } else if (item.type == "period") {
                                if(item.value2){
                                    let bDate = util.date.format(item.value, item.dateType=='datetime'?'yyyy-MM-dd hh:mm:ss':'yyyy-MM-dd')
                                    let eDate = util.date.format(item.value2, item.dateType=='datetime'?'yyyy-MM-dd hh:mm:ss':'yyyy-MM-dd 23:59:59')
                                    //有交集就查出来
                                    let s = "not(" + item.name + ">='" + eDate + "' or " + item.name2 + "<'" + bDate + "')"
                                    result = util.joinWhere(result,s)
                                }
                            }
                            else if (item.type == "checkbox") {
                                let checks = [];
                                for(let i=0;i<item.value.length;i++) {
                                    if(item.value[i][2]){
                                        let a = typeof(item.value[i][0])=="string"?"'" + item.value[i][0] + "'": item.value[i][0]
                                        checks.push(a)
                                    }
                                }
                                if(checks.length>0){
                                    result = util.joinWhere(result, item.name + " in(" + checks.join(",") + ")")
                                }
                            } else if (item.type == "radio") {
                                if(typeof(item.value)=="string"){
                                    result = util.joinWhere(result,item.name + "='" + item.value + "'")
                                }else{
                                    result = util.joinWhere(result,item.name + "=" + item.value)
                                }
                            }
                            else if(item.type == 'number'){
                                //有交集就查出来
                                //TODO:要注意0也要包含
                                if(item.value || item.value==0){
                                    result = util.joinWhere(result,item.name + ">=" + item.value)
                                }
                                if(item.value2 || item.value==0){
                                    result = util.joinWhere(result,item.name + "<=" + item.value2)
                                }
                            }
			     else if (item.type == "cascader") {
                                let val = null
                                if(item.value.length>0){
                                    val = item.value[item.value.length-1]
                                }
                                let a = typeof(val)=="string"?"'" + val+ "'": val
                                if(val){
                                    result = util.joinWhere(result, item.name + "=" + a)
                                }
                            }
                        }
                    }
		     }

                return result;
            },
            getWhere1(filters) {
                //TODO:安全起见，需要到移动服务端去实现
                let result = []
                if(filters){
                    for(let i=0;i<filters.length;i++){
                        let filteritem=null
                        let item = filters[i];
                        if(!this.isEmpty(item)) {
                            if(item.remote){  //特殊条件，以key:value传到服务端，再在服务端
                                continue
                            }
                            if (item.type == "string") {
                                filteritem={name:item.name,value:item.value,type:"string",operate:"like"}
                            } else if (item.type == "select") {
                                if(item.equal=="like"){
                                    filteritem={name:item.name,value:item.value,type:"select",operate:"like"}

                                }else {
                                    let a = typeof(item.value)=="string"?"'" + item.value + "'": item.value
                                    filteritem={name:item.name,value:a,type:"select",operate:"="}

                                }
                            } else if (item.type == "date") {
                                if(item.value[0] && item.value[1]) {
                                    let bDate = util.date.format(item.value[0], 'yyyy-MM-dd')
                                    let eDate = util.date.format(item.value[1], 'yyyy-MM-dd 23:59:59')
                                    filteritem={name:item.name,value:bDate,value1:eDate,type:"date"}
                                }
                            } else if (item.type == "period") {
                                if(item.value2){
                                    let bDate = util.date.format(item.value, item.dateType=='datetime'?'yyyy-MM-dd hh:mm:ss':'yyyy-MM-dd')
                                    let eDate = util.date.format(item.value2, item.dateType=='datetime'?'yyyy-MM-dd hh:mm:ss':'yyyy-MM-dd 23:59:59')
                                    //有交集就查出来
                                    filteritem={name:item.name,name2:item.name2,value:bDate,value1:eDate,type:"period"}
                                }
                            }
                            else if (item.type == "checkbox") {
                                let checks = [];
                                for(let i=0;i<item.value.length;i++) {
                                    if(item.value[i][2]){
                                        let a = typeof(item.value[i][0])=="string"?"'" + item.value[i][0] + "'": item.value[i][0]
                                        checks.push(a)
                                    }
                                }
                                if(checks.length>0){
                                    filteritem={name:item.name,value:checks.join(","),type:"checkbox",operate:"in"}
                                }
                            }else if(item.type == 'numberrange'){
                                //有交集就查出来
                                //TODO:要注意0也要包含
                                    filteritem={name:item.name,value:item.value,value1:item.value2,type:"numberrange"}

                            }
                            if(filteritem) {
                                result.push(filteritem)
                            }
                        }
                    }
                }
                return result;
            },
            searchChange(val,record,key){
                this.$emit("searchChange",key,val,record)
            },
            openCondition(){
                this.vCondition = !this.vCondition
                if (this.cdtnIcon == "d-arrow-left") {
                    this.cdtnIcon = "d-arrow-right"
                }else{
                    this.cdtnIcon = "d-arrow-left"
                }
            },
            packUp(){
                if (this.packupIcon == "el-icon-caret-left") {
                    this.packupIcon = "el-icon-caret-right"
                    this.$emit("onPackUp",false)
                }else{
                    this.packupIcon = "el-icon-caret-left"
                    this.$emit("onPackUp",true)
                }
            },
            createEditForm(){
              if(this.EditForm){
                return this.EditForm
              }
              if(this.editVue) {
                let C = Vue.extend(require("@/pages/"+this.editVue).default)
                let form = new C()
                form.$on("onSaveSuc", this.onSaveSuc)
                this.$el.appendChild(form.$mount().$el)
                if(this.reuseEditForm){
                  this.EditForm = form
               }else if(form.$children[0] && form.$children[0].$on){
                  //form子组件为el-dialog
                  //这里要销毁，以免使用相同窗体，状态保留出错
                  form.$children[0].$on("close",()=>{
                    form.$destroy(true);
                    this.$el.removeChild(form.$el);
                  })
                }
                return form
              }
              return null
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                let ids=this._getSelectionIDs();
                let Rows = this._getSelections();
                this.$emit("onMultipleSelect",Rows,ids)
            },
            getEditTitle(row){
                if(row.editTitle)
                {
                    return row.editTitle
                }
                if(this.authEdit)
                {
                    return "编辑"
                } else {
                    return "查看"
                }
            },
            getSummaries(param){
                if(!this.showSummary) {
                    return []
                }
                let result = []
                const { columns, data } = param;
                columns.forEach((column, index) => {
                    let r ={}
                    //this.$emit("onSum",column.property,this._wherePara(),r)
                    if(this.sumData && this.sumData[column.property] || this.sumData[column.property]===0){
                        result[index] = this.sumData[column.property]
                    }else if (index === 0) {
                        result[index] = '合计'
                    }else {
                        result[index] = ''
                    }
                })
                return result
            },
            sortchange(column){
                if(column.column) {
                    if(column.column.sortable=="custom"){
                        this.orderby=column.prop
                        this.ordertype=column.order
                        this.search();
                    }
                }else{

                }
            },
          headerdragend(newwidth,oldwitdh,column,event){
              let para = {tableName:this.tablename,columnName:column.property,width:newwidth}
              util.post('server/system/TableSetting.ashx?cmd=Save',para,this.switchLoading,result=> {

            })
          },
            getApproveTitle(row){
                if(row.ApproveTitle)
                {
                    return row.ApproveTitle
                }
                if(row.FApproveStatus==0) {
                    return "提交审核"
                }
                return "审核"
            },
            handleApprove(row){
                if(!util.emit(this,"beforeApprove",row)){
                    return;
                }
                this.createEditForm()._openApprove(row,this.ApproveID);
            }
        },
        created(){
            if(this.needAuth){
                if(!util.hasAuth("add")){
                    this.authAdd = false
                }
                if(!util.hasAuth("modify")){
                    this.authEdit = false
                }
                if(!util.hasAuth("delete")){
                    this.authDel = false
                }
            }
            if(this.autoSearch) {
                this.search(this.initWhere)
            }
        },
      mounted(){
        //this.setcolumnwidth()
      }
    }
</script>



// WEBPACK FOOTER //
// src/pages/BaseList.vue